import {ethers} from "ethers";
import {ERC20, UniswapV2Pool, UniswapV3Pool} from "web3/ABI";

import {CHAIN_ID, CHAIN_TO_PARAMS_MAP} from "web3/chains";

const getTokenContractsAndDecimals = async (chain, poolContractType) => {
    const chainParams = CHAIN_TO_PARAMS_MAP[chain]
    const provider = new ethers.providers.JsonRpcProvider(chainParams.rpcURL);
    const poolAddress = chainParams.addresses.POOL_ADDRESS;

    const poolContract = new ethers.Contract(poolAddress, poolContractType, provider);

    const token0Address = await poolContract.token0();
    const token1Address = await poolContract.token1();

    const token0Contract = new ethers.Contract(token0Address, ERC20, provider);
    const token1Contract = new ethers.Contract(token1Address, ERC20, provider);

    const decimals0 = await token0Contract.decimals();
    const decimals1 = await token1Contract.decimals();

    return {token0Contract, token1Contract, poolContract, decimals0, decimals1};
}

export const kompetePriceCalculationEthChain = async () => {
    const {poolContract, decimals0, decimals1} = await getTokenContractsAndDecimals(CHAIN_ID.ETH_MAINNET, UniswapV2Pool);

    const reserves = await poolContract.getReserves();

    const reserve0 = ethers.utils.formatUnits(reserves[0], decimals0);
    const reserve1 = ethers.utils.formatUnits(reserves[1], decimals1);

    return reserve1 / reserve0
};

export const kompetePriceCalculationBaseChain = async () => {
    const {poolContract, decimals0, decimals1} = await getTokenContractsAndDecimals(CHAIN_ID.BASE_MAINNET, UniswapV3Pool);

    const [sqrtPriceX96] = await poolContract.slot0();

    const buyOneOfToken0 = Math.pow(sqrtPriceX96 / Math.pow(2, 96), 2) / (Math.pow(10, decimals1) / Math.pow(10, decimals0)).toFixed(decimals1);
    return (1 / buyOneOfToken0).toFixed(decimals0)
};